(function ($) {
  $.noConflict();
  $(document).ready(function (){
    
    // Lazy Load
    $("img").addClass("lazyload");
    $("img.lazyload").lazyload();
    
    // Open Measure Tool
    var hash = window.location.hash.substring(1); //Puts hash in variable, and removes the # character

    if(hash == "open-tool") {   
      setTimeout(function(){
        $('button[type="button"].o-btn--add-to-cart').trigger("click");
      }, 250);
    }

    // Compare List Accordion
    var acc = document.getElementsByClassName("accordion");
    var i;

    for (i = 0; i < acc.length; i++) {
      acc[i].addEventListener("click", function() {
        this.classList.toggle("active");
        var panel = this.nextElementSibling;
        if (panel.style.display === "block") {
        panel.style.display = "none";
        } else {
        panel.style.display = "block";
        }
      });
    }

    $('.compare-list-accordion button.accordion').on('click', function(){
      $(this).closest('span').toggleClass('active');
    });

    // Blog Videos
    $('.c-article-template__body p:has(iframe)').addClass('videoContainer');



    // customSlider();

    if (Shopify.designMode) {
      document.addEventListener('shopify:section:load', function() {
        customSlider();
      });
    }

    $(document).on("click",".close-topbar",function() {
      sessionStorage.setItem("announcementbar", false);
      $(".o-top-bar").slideUp();
    });

    var $menuTrigger = $('.js-menuToggle');
    var $topNav = $('.js-topPushNav');
    var $openLevel = $('.js-openLevel');
    var $closeLevel = $('.js-closeLevel');
    var $closeLevelTop = $('.js-closeLevelTop');
    var $navLevel = $('.js-pushNavLevel');
    var $closeLevelInprogress = false;

    function openPushNav() {
      $topNav.addClass('isOpen');
      $('body').addClass('pushNavIsOpen');
    }

    function closePushNav() {
      $topNav.removeClass('isOpen');
      $openLevel.siblings().removeClass('isOpen');
      $('body').removeClass('pushNavIsOpen');
    }

    $menuTrigger.on('click touchstart', function(e) {
    e.preventDefault();
      if ($topNav.hasClass('isOpen')) {
        closePushNav();
      } else {
        openPushNav();
      }
    });

    $openLevel.on('click', function(e){
      $(this).next($navLevel).addClass('isOpen');
    });

    $closeLevel.on('click', function(){
      if(!$closeLevelInprogress){  
        $(this).closest($navLevel).removeClass('isOpen');
        $closeLevelInprogress = true;
        setTimeout(() => {
          $closeLevelInprogress = false;
        }, 500);
      }
    });

    $closeLevelTop.on('click', function(){
      closePushNav();
    });

    $('.screen').click(function() {
      closePushNav();
    });

    var playButtonClass = ".js-play-button";
    $(document).on("click", playButtonClass, function () {
      let videoSelector = $(this).next(),
      videoObject = videoSelector.get(0);
      $(this).toggleClass("active");

      videoSelector.toggleClass("active");
      $(this).closest(".video_image_banner").toggleClass("video_playing");
      if ($(this).hasClass("youtube_video")) {
        var videoURL = videoSelector.prop("src");
        if (videoSelector.hasClass("active")) {
          // videoURL += "&mute=1&autoplay=1";
          // videoSelector.prop("src", videoURL);
        } else {
          // videoURL = videoURL.replace("&mute=1&autoplay=1", "");
          // videoSelector.prop("src", "");
          // videoSelector.prop("src", videoURL);
        }
      }  else {
        videoObject.paused ? videoObject.play() : videoObject.pause();
      }
    });
    var intervalId = window.setInterval(function(){
      var filterLen = $(".custom-collection-wrapper .boost-pfs-filter-tree-mobile-button button").length;
      if(filterLen>0){
        $(".custom-collection-wrapper .boost-pfs-filter-tree-mobile-button button").text("Filter");
        clearInterval(intervalId);
      }        
    }, 2000);

    $(document).on("click",".compare-link",function() {
        $(".compare-popup-main").show();
    });

    $(document).on("click",".lity-close",function() {
      $(".compare-popup-main").hide();
    });

    $(document).on("click","#popup_add_btn",function() {
      $('.c-product-template__details').addClass('product_full_info_sticky');
      $('body').addClass('product_info_sticky_overlay');    
      $('.product_infobar_slider').slick('refresh');
      $('.product_infobar_slider').slick();
    });

    $(document).on("click",".product-atc-sticky-close",function() {
      $('.c-product-template__details').removeClass('product_full_info_sticky');
      $('body').removeClass('product_info_sticky_overlay');
    });

    $(document).on("click",".product-atc-sticky-close.atc-sticky-bar",function() {
      $(this).parent().hide();
    });

    $(document).click(function(event) {
      if (!$(event.target).closest(".c-product-template__details, .product_full_info_sticky").length) {
        $('body').removeClass('product_info_sticky_overlay');
        $('.c-product-template__details').removeClass('product_full_info_sticky');
      }
    });

    $(window).scroll(function(){ 
      if($("body.c-page--product").length > 0){
        if($('.c-product-template__details.product_full_info_sticky').length == 0){
          if($('.custom_form_wrapper form:not(.product_info_sticky)').length > 0){
            theme_custom.productDetailsHeight = $('.custom_form_wrapper form').height();
            theme_custom.productDetailsHeightOnlyForm = theme_custom.productDetailsHeight;
            if(window.matchMedia('(max-width: 1024px)').matches){
              theme_custom.productDetailsHeight += $('.product-details-page-main .c-product-template__carousel').height();
            }
          }
          var addToCartOffsetTop = theme_custom.productDetailsHeight;
          if ($(this).scrollTop() > addToCartOffsetTop) { 
            $('.custom_form_wrapper').css('padding-bottom',theme_custom.productDetailsHeightOnlyForm+'px');
            $('.c-product-template__details').addClass('product_info_sticky'); 
          } else { 
            $('.custom_form_wrapper').css('padding-bottom','');
            $('.c-product-template__details').removeClass('product_info_sticky');
            $('.product_infobar_slider').slick('refresh');
          }
        }else{
          $('body').removeClass('product_info_sticky_overlay');
          $('.c-product-template__details').removeClass('product_full_info_sticky');
        }
      }
    }); 
    $(".compare-popup-main").append('<button class="custom-popup-close lity-close" type="button" aria-label="Close (Press escape to close)" data-lity-close=""></button>');

    $(document).ready(function() {
      // var descriptionFull = document.querySelector('.product-description-full');
      //   descriptionFull.style.display = 'none';
      $('.readmore').click(function (event) {
        event.preventDefault();
        var descriptionFull = document.querySelector('.product-description-full');
        descriptionFull.style.display = 'block';
        var descriptionShort = document.querySelector('.product-description-short');
        descriptionShort.style.display = 'none';
      });
      $('.readless').click(function (event) {
        event.preventDefault();
        var descriptionFull = document.querySelector('.product-description-full');
        descriptionFull.style.display = 'none';
        var descriptionShort = document.querySelector('.product-description-short');
        descriptionShort.style.display = 'block';
      });  
    });

    $(".dropdown dt").on('click', function() {
      if($(this).closest(".dropdown").hasClass("active")){
        $(this).closest(".dropdown").removeClass("active");
      }else{
        $(".dropdown").removeClass("active");
        $(this).closest(".dropdown").addClass("active");
      }
    });

    $(".mobile-view .cancel-btn").on('click', function() {
      $(this).closest(".top-sub-filter-wrapper").removeClass("blog-filter-open");
      $("body").removeClass("blog-filter-overlay");
    });

    $('body').click(function(e){
      if($(e.target).closest('.top-sub-filter-wrapper').length == 0  && $(e.target).closest('.filter-button').length == 0 ){
        $('.top-sub-filter-wrapper').removeClass('blog-filter-open');
        $('body').removeClass('blog-filter-overlay');
      }
      if($(e.target).closest(".top-sub-filter-wrapper").length == 0){
        $(".dropdown").removeClass("active");
      }
    });

    $(".filter-button .open-button").on("click", function () {
      $(this).closest(".tagfilter-search-main").find(".top-sub-filter-wrapper").addClass("blog-filter-open");
      $('body').addClass("blog-filter-overlay");
      return false;
    });

    $(".filter-close img").on("click", function(){
      $(this).closest(".tagfilter-search-main").find(".top-sub-filter-wrapper").removeClass("blog-filter-open");
      $('body').removeClass("blog-filter-overlay");

    });
      

    function getSelectedTag(){
      var checkedTag = [];
      var tags = '';
      var currentURL = window.location.pathname;
      var activeTag = $(".tab-blog .blog-url.active").attr("href");
      $(".mutliSelect input:checkbox[name=taglist]:checked").each(function () {
        checkedTag.push($(this).val());
      });
      $(checkedTag).each(function (i,val) {
        if(i != checkedTag.length - 1){
          tags += checkedTag[i] + '+';
        }
        else{
          tags += checkedTag[i];
        }
      });

      if(tags != ''){
        if(activeTag.includes('tagged')){
          finalURL = activeTag + `+${tags}`;
        }
        else{
          finalURL = activeTag + `/tagged/${tags}`;
        }
      }
      else{
        finalURL = activeTag;
      }
    
      window.location.href = finalURL;
    }
    $(document).on("click",".apply-btn",function() {
      getSelectedTag();
    });
    
    var getTagPath = window.location.pathname;
    var splitTag = '';
    if(getTagPath.includes('tagged')){
      getTagPath = getTagPath.split("tagged/");
      if(getTagPath[1].includes('+')){
        splitTag = getTagPath[1].split("+");
      }
      else{
        splitTag = getTagPath[1];
        checkTag(splitTag);
      }
    }

    
    function checkTag(val){
      $(`.mutliSelect input[value=${val}]`).attr('checked','checked');
      var html = '<span class="tag-value" value="'+val+'" title="' + val + '">' + val + '<span class="close-tag"><img src="https://cdn.shopify.com/s/files/1/0109/0663/2256/files/close-icon-filter.png"></span></span>';
      $(`.mutliSelect input[value=${val}]`).closest('.dropdown').find('.multiSel').append(html);
      $(`.mutliSelect input[value=${val}]`).addClass("selected");
      $(`.mutliSelect input[value=${val}]`).closest('.dropdown').find(".hida").hide();
    }

    $(splitTag).each(function (i,val) {
      checkTag(val);
    });

    $(".close-tag").on("click", function(){
      var remove_tag = $(this).closest(".tag-value").attr("title");
      $(this).closest(".dropdown").find(`.mutliSelect input[value=${remove_tag}]`).attr('checked',false);
      $(this).closest(".tag-value").remove();
      getSelectedTag();
    });
    

    $(".tag-apply-btn-wrapper .cancel-btn").on("click", function(){
      $(this).closest(".blog-filter-block").find(".dropdown").removeClass("active");
    });

    $(".search-icon-blog").on("click", function(){
      $(this).closest(".blog-search-right").addClass("search-open");
      $("input.custom").focus();
    });

    $(".search-close-blog").on("click", function(){
      $(this).closest(".blog-search-right").removeClass("search-open");
      $(this).closest(".input-with-search").find("input.custom").val("");
    });
    var description = $('.additional-description');
    var showMoreButton = $('.show-more');
    var showLessButton = $('.show-less');
  
    $(showMoreButton).click(function() {
      $(description).addClass("addHeight");
      $(this).css("display","none");
      $(showLessButton).css("display","inline");
    });
  
    $(showLessButton).click(function() {
      $(description).removeClass("addHeight");
      $(this).css("display","none");
      $(showMoreButton).css("display","inline");
    });
  });
})(jQuery);

jQuery(document).ready(function( $ ){
  setTimeout(function(){ 
    $( ".c-article-template__aside" ).insertBefore( "#relatedblogs" );
  }, 10);
});


theme_custom.clickEvent = function(){
    jQuery(document).on('click', '.faq-section .faq-accordian .title', function(){
        if($(this).closest('.faq-accordian').hasClass('active')){
            $(this).parents('.faq-section').find('.faq-accordian').removeClass('active');
        }else{
            $(this).parents('.faq-section').find('.faq-accordian').removeClass('active');
            $(this).parent('.faq-accordian').addClass('active');
        }    
    });
}

theme_custom.slickSlider = function(){
    var imgCardSlider = setInterval(function() {
        var imgCardSliderLength = jQuery('.image_card_slider_section').length;
        if(imgCardSliderLength > 0){
            theme_custom.imgCardSlider();
            clearInterval(imgCardSlider);
        }
    },100);
    theme_custom.imgCardSlider = function(){  
        jQuery(".image_card_slider_section").slick({
            infinite: false,
            dots: true,
            arrows:false,
            slidesToScroll: 1,
            slidesToShow: 1.5
        });
    }
}

// Snow Slides
theme_custom.slickSliderProd = function(){
  $('.custom_collection_tab_slider').slick({
    responsive: [
      {
        breakpoint: 749,
        settings: {
          centerMode: false,
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: false,
          dots: true
        }
      }
    ]
  });

  $(".image-video-slider").slick({
    infinite: false,
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1.3,
          slidesToScroll: 1,
          arrows: false,
        }
      }
    ]
  });
  $(".featured-slider").slick();

  $(".similar-variant.slider").slick({
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  });

  setTimeout(() => {
    $('.similar-variant .product_slick').slick({
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      dots: false
    });
  }, 500);


  
  var RecommendedId = window.setInterval(function(){
  var RecommentSliderLength = $(".recommended.slider").length;
    if(RecommentSliderLength > 0){
      $(".recommended.slider").slick({
        infinite: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        responsive: [
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          }
        ]
      });
      clearInterval(RecommendedId);
    }
  }, 1000);

  var productDrawerSlickId = window.setInterval(function(){
    var productSlickLen = $(".drawer-recommendations .drawer-slider").length;
    if(productSlickLen > 0){
        setTimeout(() => {
          $('.drawer-recommendations .drawer-slider').slick({
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots: false
          });
        }, 100);
        clearInterval(productDrawerSlickId);
      }
    }, 100);

    var productSlickId = window.setInterval(function(){
      var productSlickLen = $(".recommended .product_slick").length;
      if(productSlickLen > 0){
          setTimeout(() => {
            $('.recommended .product_slick').slick({
              infinite: false,
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: true,
              dots: false
            });
          }, 1000);
          clearInterval(productSlickId);
        }
      }, 1000);

  var okendoSection = window.setInterval(function(){
    var test = $(".custom-okendo-reviews-main-wrapper").find("div[data-reviews-description]");
    var okendoLen = test.length;
    if(okendoLen > 0){
      setTimeout(() => { 
        var desc = test.attr("data-reviews-description");
        var find_header = $(".custom-okendo-reviews-main-wrapper").find(".okeReviews-reviewsCarousel-header .okeReviews-reviewsCarousel-heading");
        $(`<div class="okeReviews-reviewsCarousel-text text-xl">${desc}</div>`).insertAfter(find_header);
      }, 2000);
      clearInterval(okendoSection);
    }
  }, 3000);



  $('.video_new_slider').slick({
    dots: true,
    infinite: false,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll:1,
    arrows: false,
    appendDots: '.video_new_slider',
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false
        }
      }
    ]
  });


  // $('.featured-collection').slick({
  //   mobileFirst: true,
  //   infinite: true,
  //   dots: true,
  //   infinite: false,
  //   arrows: false,
  //   slidesToShow: 1.2,
  //   slidesToScroll: 1,
  //   responsive: [
  //     {
  //       breakpoint: 750,
  //       settings: "unslick"
  //     }
  //   ]    
  // });

  mobileOnlySlider(".featured-collection, .new-collection-products", true, false, 749);

  function mobileOnlySlider($slidername, $dots, $arrows, $breakpoint) {
    var slider = $($slidername);
    var settings = {
      mobileFirst: true,
      infinite: false,
      dots: $dots,
      slidesToShow: 1.2,
      slidesToScroll: 1,
      arrows: $arrows,
      responsive: [
        {
          breakpoint: $breakpoint,
          settings: "unslick"
        }
      ]
    };

    slider.slick(settings);

    $(window).on("resize", function () {
      if ($(window).width() > $breakpoint) {
        return;
      }
      if (!slider.hasClass("slick-initialized")) {
        return slider.slick(settings);
      }
    });
  } // Mobile Only Slider

}

theme_custom.deawerAddtoCart = function(){
  $(document).on("click", ".drawer-add", function(){
    var getID = $(this).closest(".drawer-add-to-cart").find(".getProductId").val();
    var quantity = 1;
    var params = {
      type: 'POST',
      url: '/cart/add.js',
      data: 'quantity=' + quantity + '&id=' + getID,
      dataType: 'json',
      success: function(line_item) { 
        $.ajax({
          url: '/cart',
          success: function(data) {
           var finalData = $(data).find(".drawer__wrapper .drawer__content").html();
           theme_custom.cartCountItems(line_item);
           $(".drawer__wrapper .drawer__content").html(finalData);
          }
        });
      }
    };
    jQuery.ajax(params);
  });
}

theme_custom.deawerRemovePrd = function(){
  $(document).on("click", "[data-cart-drawer-page-remove-item]", function(event){
    event.preventDefault();
    var getID = $(this).closest(".product-remove").find("a").attr("variant_id");
    var quantity = 0;
    theme_custom.drawerChangeEvent(quantity, getID);
  });
}

theme_custom.cartRemovePrd = function(){
  $(document).on("click", "[data-cart-page-remove-item]", function(event){
    event.preventDefault();
    var getID = $(this).closest(".product-remove").find("a").attr("variant_id");
    var quantity = 0;
    theme_custom.cartChangeEvent(quantity, getID);
  });
}

theme_custom.cartChangeQty = function(){
  $(document).on("change", ".cart-page-quantity .quantity__input", function(){
    var getID = $(this).closest(".product-quantity").find(".getVariant").val();
    var quantity = $(this).val();
    theme_custom.cartChangeEvent(quantity, getID);
  });
}

theme_custom.cartDrawerChangeQty = function(){
  $(document).on("change", ".main-cart-drawer-side .quantity__input", function(){
    var getID = $(this).closest(".product-quantity").find(".getVariant").val();
    var quantity = $(this).val();;
    theme_custom.drawerChangeEvent(quantity, getID);
  });
}

theme_custom.cartCountItems = function(line_item){
  var cartQuantity = line_item.item_count;
  $("span.c-header__icon-cart__count").html(cartQuantity);
}

theme_custom.drawerChangeEvent = function(quantity, variant_ID){
  var params = {
    type: 'POST',
    url: '/cart/change.js',
    data: 'quantity=' + quantity + '&id=' + variant_ID,
    dataType: 'json',
    success: function(line_item) { 
      $.ajax({
        url: '/cart',
        success: function(data) {
          var finalData = $(data).find(".main-cart-drawer-side .cart_items").html();
          var finalCheckout = $(data).find(".main-cart-drawer-side .cart-checkouts").html();
          var cartQuantity = line_item.item_count;
          if(cartQuantity > 0){              
            $(".main-cart-drawer-side .cart_items").html(finalData);
            $(".main-cart-drawer-side .cart-checkouts").html(finalCheckout);
            theme_custom.cartCountItems(line_item);
          }else{
            location.reload(true);
          }
        }
      });
    }
  };
  jQuery.ajax(params);
}

theme_custom.cartChangeEvent = function(quantity, variant_ID){
  var params = {
    type: 'POST',
    url: '/cart/change.js',
    data: 'quantity=' + quantity + '&id=' + variant_ID,
    dataType: 'json',
    success: function(line_item) { 
      $.ajax({
        url: '/cart',
        success: function(data) {
         var finalData = $(data).find(".main-cart-page .cart_items").html();
         var cartQuantity = line_item.item_count;
         var finalCheckout = $(data).find(".main-cart-page .cart-checkouts").html();
         var cartTotal = line_item.total_price / 100;
         var getDisPrice = $(data).find("input.discount-price-cart").val();
         var throwPrice = getDisPrice - cartTotal;
         var mainContent = "";
         if(cartTotal > getDisPrice){
            mainContent = '<p class="free-shipping-cart text-lg">*Free shipping</p>';
         }else{
            mainContent = '<p class="free-shipping-cart text-lg">Spend another $' + throwPrice + '</p>';
         }
         if(cartQuantity > 0){
          $(".main-cart-page .free-shipping-bar").html(mainContent);
          theme_custom.cartCountItems(line_item);
          $(".main-cart-page .cart_items").html(finalData);
          $(".main-cart-page .cart-checkouts").html(finalCheckout);
         }else{
          location.reload(true);
         }
        }
      });
    }
  };
  jQuery.ajax(params);
}
theme_custom.collectionProductSlider = function(){
  setTimeout(() => {
    $('.product_slick').slick({
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      dots: false
    });
  }, 500);
}


theme_custom.ndisSupportSlider = function(){
      $('.slick-carousel-support').slick({
      infinite: true,
      centerMode: false,
      centerPadding: '10px',
      autoplay: true,
      speed: 300,
      slidesToShow: 4,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            infinite: true,
            dots: true
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ]
    });
}
theme_custom.pdp_inforbarSlider = function(){
  $('.product_infobar_slider')?.slick({
    dots: false,
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 2,
    arrows:false,
    cssEase: 'ease',
    speed: 1000 ,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  })
}

theme_custom.init = function () {
  theme_custom.clickEvent();
  theme_custom.slickSlider();
  theme_custom.slickSliderProd();
  theme_custom.deawerAddtoCart();
  theme_custom.cartChangeQty();
  theme_custom.cartDrawerChangeQty();
  theme_custom.deawerRemovePrd();
  theme_custom.cartRemovePrd();
  theme_custom.ndisSupportSlider();
  theme_custom.pdp_inforbarSlider();
};
jQuery(document).ready(function () {
  theme_custom.init();
}); 
/* Footer menu */

/* Footer menu */

jQuery(document).on('click', '.block_section_grid_footer_menu_main .accordion_menu .menu_title', function(){
    if($(this).closest('.accordion_menu').hasClass('active')){
      $(this).parents('.block_section_grid_footer_menu_main').find('.accordion_menu').removeClass('active');  
    }else{    
      $(this).parents('.block_section_grid_footer_menu_main').find('.accordion_menu').removeClass('active');
      $(this).parent('.accordion_menu').addClass('active');
    }
});

document.addEventListener("DOMContentLoaded", function() {
  var more_button = document.querySelectorAll(".more_next");
  var less_button = document.querySelectorAll(".less_next");

  more_button.forEach(button => button.addEventListener('click',function(){
    var closest_main = this.closest('.main-blog-wrap');
    var div_list = closest_main.querySelectorAll('.flex-blog article');
    div_list.forEach(function(val,index){
      val.style.display = "block";
    });
    closest_main.querySelector('.more_next').style.display = "none";
    closest_main.querySelector('.less_next').style.display = "block";
  }))

  less_button.forEach(button => button.addEventListener('click',function(){
    var closest_main = this.closest('.main-blog-wrap');
    var div_list = closest_main.querySelectorAll('.flex-blog article');
    div_list.forEach(function(val,index){
      if(index > 2){
        val.style.display = 'none';
      }
      closest_main.querySelector('.more_next').style.display = "block";
      closest_main.querySelector('.less_next').style.display = "none";
    });
  }))

    $(document).on('keyup keypress', '.blog-search__input.custom',function(event){
    var searchInput =document.querySelector('.blog-search__input.custom').value;
    $(this).closest(".main-blog-search-result").find(".algolia-autocomplete").addClass("custom-search-blog-title");
    
    if(searchInput.length > 0){
      var searchUrl = window.Shopify.routes.root + "search/suggest.json?q=" + encodeURIComponent(searchInput) + "&resources[type]=article&resources[options][fields]=title,author";
      fetch(searchUrl)
        .then(function(response) {
          if (response.ok) {
            return response.json();
          } else {
            throw new Error('Error: ' + response.status);
          }
        })
        .then(function(data) {
          var html_list = '' , main_container = '';
          var article_list = data.resources.results.articles;
          if(article_list.length > 0){
            article_list.forEach(function(list,index){
              var article_title = list.title ;
              var article_url = list.url;
              html_list += `<a href="${article_url}"><div class="article-list">${article_title}</div></a>`;
            })
          }else{
            html_list = `<div class="article-list-no-data">No data found.</div>`
          }
          main_container = `<div class="main-container">${html_list}</div>`;
          $('.custom-search-blog-title').html(main_container);
        })
        .catch(function(error) {
      });
    }
    else{
      $(".main-blog-search-result .algolia-autocomplete").removeClass("custom-search-blog-title");
    }
  });
  
    $(".c-header__menu-link-item").hover(function() {     
      $("body").addClass("megamenu-overlay");
    }, function() {      
      $("body").removeClass("megamenu-overlay");
    });  

    var getB2bUrl = window.location.href;
    if(getB2bUrl.match("contact_posted=true")){
      $(".b2b-popup a.button").trigger("click");
      setTimeout(function(){ 
        $(".lity-wrap").click();
      }, 2000); 
    }

    if(getB2bUrl.match("#b2b-contact-form")){
      setTimeout(function(){ 
        $(".second-content .view-all a.button").trigger("click");
      }, 15000); 
    }

    $('.c-header__menu').each(function(){
     $(this).find('li a[href="#popup-menu-header"]').attr('data-lity','');
    });

    $('.thard-leval-menu').each(function(){
      $(this).find('li a[href="#popup-menu-header"]').attr('data-lity','');
     });

  $('.accordion_menu').each(function(){
      $(this).find('li a[href="#popup-menu-header"]').attr('data-lity','');
     });

  $('.mobile_bottom_menu').each(function(){
      $(this).find('li a[href="#popup-menu-header"]').attr('data-lity','');
     });

});

